import { colorTokens } from '@/apps/legacy/shared/styles/colorTokens'

export const REQUEST_ID_STYLES = {
  fontSize: '0.75rem',
  colors: {
    text: colorTokens.text.secondary,
    icon: colorTokens.grey[500],
    iconHover: colorTokens.blue[500],
  },
} as const

export const CARD_STYLES = {
  backgroundColor: colorTokens.background.paper,
  borderRadius: 2,
  border: `1px solid ${colorTokens.border.light}`,
  boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
} as const

export const SECTION_HEADER_STYLES = {
  mb: 2,
  color: colorTokens.text.primary,
} as const
